<button
  class="sm !rounded-md !px-5"
  mat-stroked-button
  [mat-dialog-close]="false">
  <div class="flex gap-2 w-full text-[#353C40] border-[#353C40] text-[.8rem]">
    <fa-icon [icon]="faClose" class="text-[#353C40]" />
    Cancel
  </div>
</button>
